import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

// perfect scrollbar
import { NgScrollbarModule } from 'ngx-scrollbar';

//Import all material modules
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
//Import Layouts
import { BlankComponent } from './layouts/blank/blank.component';

import { CoreModule } from './core/core.module';
import { ConfigService } from './core/services/config-service';
import { LayoutModule } from './layouts/layout.module';
import { ApisModule } from './services/apis.module';
import { provideStore } from '@ngxs/store';
import { PermissionsState } from './store-ngxs/states/permissions.state';
import { ProfileState } from './store-ngxs/states/profile.state';
import { RoleState } from './store-ngxs/states/role.state';
import { MenuState } from './store-ngxs/states/menu.state';
import { OptionsState } from './store-ngxs/states/options.state';
import { AuthState } from './store-ngxs/states/auth.state';
import { UsersState } from './store-ngxs/states/users.state';
import { TranslationService } from './services/translation.service';
import { LabelState } from './store-ngxs/states/labels.state';
import { NotificationState } from './store-ngxs/states/notification.state';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AuthService } from './services/auth.service';

@NgModule({
  declarations: [AppComponent, BlankComponent],
  exports: [TablerIconsModule],
  bootstrap: [AppComponent],
  imports: [
    CoreModule,
    LayoutModule,
    ApisModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TablerIconsModule.pick(TablerIcons),
    NgScrollbarModule,
  ],
  providers: [
    provideStore([
      AuthState,
      PermissionsState,
      ProfileState,
      RoleState,
      MenuState,
      OptionsState,
      LabelState,
      UsersState,
      NotificationState,
    ]),
    {
      provide: APP_INITIALIZER,
      useFactory: (cfg: ConfigService, tr: TranslationService, auth: AuthService) => {
        return async () => {
          await cfg.setConfig();
          tr.setCurrentLanguage('');
          await tr.subscribeForLanguagesAsync();
          if (!window.location.pathname.startsWith('/origin-form')) {
            await auth.init();
          }
        }
      },
      deps: [ConfigService, TranslationService, AuthService],
      multi: true,
    },
    {   
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic' },
    },
    provideHttpClient(withInterceptorsFromDi()), 
  ],
})
export class AppModule {}
